import { render } from "./Dashboard.vue?vue&type=template&id=0665b191"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Pages/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0665b191"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0665b191', __exports__)) {
    console.log('reload')
    api.reload('0665b191', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=0665b191", () => {
    console.log('re-render')
    api.rerender('0665b191', render)
  })

}


export default __exports__